import { render, staticRenderFns } from "./ConvenzioneTirFormativoSign.vue?vue&type=template&id=286d9bb4&scoped=true&"
import script from "./ConvenzioneTirFormativoSign.vue?vue&type=script&lang=ts&"
export * from "./ConvenzioneTirFormativoSign.vue?vue&type=script&lang=ts&"
import style0 from "./ConvenzioneTirFormativoSign.vue?vue&type=style&index=0&id=286d9bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d9bb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VIcon,VRow})
